import { render, staticRenderFns } from "./xzcfsxgzs.vue?vue&type=template&id=2493299e&scoped=true&"
import script from "./xzcfsxgzs.vue?vue&type=script&lang=js&"
export * from "./xzcfsxgzs.vue?vue&type=script&lang=js&"
import style0 from "./xzcfsxgzs.vue?vue&type=style&index=0&id=2493299e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493299e",
  null
  
)

export default component.exports